import axios from "axios";

export const getExchangeApi = async (
  lang,
  cookies,
  setExchange,
  setMessageResponse,
  setData
) => {
  const token = cookies.__t0ken_amar_management;

  let config = {
    method: "get",
    url: `${process.env.REACT_APP_API}/exchange-rates`,
    headers: {
      lan: lang,
      Authorization: `Bearer ${token}`,
    },

    timeout: 15000,
  };

  try {
    const res = await axios(config);
    setExchange((prev) => ({ ...prev, data: res.data.data, loader: false }));
    setData((prev) => ({ ...prev, RMB: res.data.data.RMB.rate, dinar: res.data.data.dinar.rate }));
  } catch (error) {
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
